"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/AGFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_6)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_6`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "black"
				}),
				/* @__PURE__ */ n("path", {
					d: "M0.231639 9.57895C0.0772526 10.4842 -0.00695801 11.4175 -0.00695801 12.3719C-0.00695801 13.3263 0.0772526 14.2667 0.231639 15.1649L11.965 16.0211L23.6983 15.1719C23.8527 14.2667 23.9369 13.3333 23.9369 12.3789C23.9369 11.4246 23.8527 10.4842 23.6983 9.58597",
					fill: "#0072C6"
				}),
				/* @__PURE__ */ n("path", {
					d: "M23.6982 15.3684H0.231567C1.34034 20.2667 6.17543 23.9509 11.9649 23.9509C17.7544 23.9509 22.5895 20.2667 23.6982 15.3684Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M19.6772 9.57894H4.25269L7.40356 8.09824L5.72637 5.04561L9.15093 5.70525L9.579 2.24561L11.965 4.78596L14.3509 2.24561L14.779 5.70525L18.2036 5.04561L16.5264 8.09824L19.6772 9.57894Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 24L-6 0V24H12Z",
					fill: "#CE1126"
				}),
				/* @__PURE__ */ n("path", {
					d: "M30.0001 24V0L11.965 24H30.0001Z",
					fill: "#CE1126"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_6`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as AGFlag };
